"use client";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import Image from "next/image";
import {useTranslations} from 'next-intl';

const BuilderSlider = () => {
  const t = useTranslations('builderAlt');
  // Снимаем aria-hidden, который slick ставит на неактивные слайды (внутри них
  // фокусируемый контент → невалидное дерево доступности, axe aria-hidden-focus).
  const stripAriaHidden = () => {
    document
      .querySelectorAll('.slider_wrapper .slick-slide[aria-hidden="true"]')
      .forEach((el) => el.removeAttribute("aria-hidden"));
  };

  const settings = {
    dots: true,
    infinite: true,
    autoplay:true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    onInit: stripAriaHidden,
    onReInit: stripAriaHidden,
    afterChange: stripAriaHidden,
  };

  const slides = [
    { id: 1, image: '/builder_slide_1.avif', title: t('slide_1') },
    { id: 2, image: '/builder_slide_2.avif', title: t('slide_2') },
    { id: 3, image: '/builder_slide_3.avif', title: t('slide_3') },
    { id: 4, image: '/builder_slide_4.avif', title: t('slide_4') },
  ];

  return (
    <div className="slider_wrapper">
      <Slider {...settings}>
        {slides.map(slide => (
          <div key={slide.id} className="relative w-full xl:h-[600px] h-[460px] ">
            <Image
              src={slide.image}
              alt={slide.title}
              fill
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              quality={60}
              // Секция ниже первого экрана, а react-slick держит все 4 слайда в DOM
              // сразу → без lazy они грузились наперёд (~210KB на 1 экране). loading=
              // lazy: подгружаются по мере подъезда/автопрокрутки, не мешая LCP хироя.
              loading="lazy"
              style={{ objectFit: 'cover',borderRadius:"30px" }}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default BuilderSlider;



